import styled from 'styled-components';
import { ModalBackdrop, modalPanelDialog } from '../ModalPrimitives.styled';

export { ModalBackdrop };

export const ModalContainer = styled.div`
  ${modalPanelDialog}
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 48px 40px 60px;
  transform: translate(-50%, -50%);
`;
export const CloseBtn = styled.button`
  position: absolute;
  right: 20px;
  top: 20px;
  background-color: transparent;
  border: none;
  cursor: pointer;

  transition: 250ms;

  :hover {
    transform: scale(1.2);
  }
`;
export const TitleText = styled.p`
  margin-bottom: 24px;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  color: ${p => p.theme.colors.text.text};
`;
export const BtnsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 14px;
`;
export const Button = styled.button`
  width: 95px;
  height: 42px;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  letter-spacing: 0.02em;
  box-shadow: ${p => p.theme.modal.chipNeutralShadow};
  transition-property: transform;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  :hover {
    transform: scale(1.1);
  }
`;
export const ConfirmBtn = styled(Button)`
  color: #ffffff;
  background-color: ${p => p.theme.colors.main.orangeMain};
`;
export const CancelBtn = styled(Button)`
  color: ${p => p.theme.colors.text.text};
  background-color: ${p =>
    p.theme.ui.scheme === 'dark'
      ? p.theme.colors.main.orangeLight
      : p.theme.colors.main.white};
  border: 1px solid ${p => p.theme.colors.main.grayLight};
`;
